import {
  DataNoRowOverlayComponent,
  DateClientSideFilterComponent,
  LoadingCellRendererComponent,
  StarredCellRendererComponent,
} from '@y42/ag-grid';
import { GridOptions } from 'ag-grid-community';
import { AssetStatusCellRendererComponent } from './asset-status-cell-renderer/asset-status-cell-renderer.component';
import { EntityTypeCellRendererComponent } from './entity-type-cell-renderer/entity-type-cell-renderer.component';
import { EntryGroupCellRendererComponent } from './entry-group-cell-renderer/entry-group-cell-renderer.component';
import { SubEntryCellRendererComponent } from './sub-entry-cell-renderer/sub-entry-cell-renderer.component';
import { TagsCellRendererComponent } from './tags-cell-renderer/tags-cell-renderer.component';

export function getDatasourceListFrameworkComponents(): GridOptions['components'] {
  return {
    entryGroup: EntryGroupCellRendererComponent,
    entryType: EntityTypeCellRendererComponent,
    dateFilter: DateClientSideFilterComponent,
    subEntry: SubEntryCellRendererComponent,
    loading: LoadingCellRendererComponent,
    dataNoRowOverlayComponent: DataNoRowOverlayComponent,
    tags: TagsCellRendererComponent,
    starred: StarredCellRendererComponent,
    // jobStatus: JobStatusHeaderRendererComponent,
    assetStatus: AssetStatusCellRendererComponent,
  };
}
